import type { FaireProductEntity } from "../../entity_types/product";

export const p_bj3ahjh2g7: FaireProductEntity = {
  token: "p_bj3ahjh2g7",
  type: "product",
  name: "Clay | Dipped Beeswax Taper Candles | All Natural",
  brandToken: "b_94ned2lnmo",
  brandName: "Mo&Co Home",
  imageUrl:
    "https://cdn.faire.com/fastly/af396e64bb1584683774bf34c2af46428201fb44eba48fa479a7aa452d8f973c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d46789c4f0d06ab6eb694687fcacfb0aecd748d2f52fd2d173fe31572db789fc.jpeg",
    "https://cdn.faire.com/fastly/1f039c62dedc0e1a7af0a07c265414d5a8042ed08f4f7b686161eb38bcddaa1d.jpeg",
    "https://cdn.faire.com/fastly/2f6394ab193c01beb6c5b71955958d675559198cb0b6d9927496f6ac3a3fec55.jpeg",
    "https://cdn.faire.com/fastly/09f4062b29ae128c5e61d58a63d724616257927e39b41399721fa67d91d9a444.jpeg",
  ],
  priceDollars: 9.5,
  description:
    "Dipped Beeswax Candles\nTwo Length Options: 10 inches & 14 inches\nSold in pairs\n\n𝐈𝐧𝐠𝐫𝐞𝐝𝐢𝐞𝐧𝐭𝐬:\n100% Beeswax\nCotton Wick\nEco-conscious coloring\n\nEach candle is handcrafted with care and dipped over 25 times.\n\n𝐖𝐡𝐲 𝐰𝐞 𝐥𝐨𝐯𝐞 𝐛𝐞𝐞𝐬𝐰𝐚𝐱:\n• When burned, beeswax candles emit negative ions that purify the air making it the cleanest burning wax available.\n• When you purchase beeswax products, you are supporting the bee farmers who colonize and encourage bee reproduction.\n• Beeswax naturally smells like honey and wildflowers!\n\n♲ Candles ship in recycled packaging materials.\n\nMade in the USA\n\nUsage:\nBohemian Home Decor, Minimalist Spaces, Spring Gatherings, Special Occasions, Wedding Decor, Housewarming Gifts, Boutique Displays, Handmade Market\nNotes:\nHand-Dipped, Natural Beeswax, Warm Earthy Tones, Cotton Wicks, Non-Toxic, Paraffin Free, Soy Free, Lead Free, Petroleum Free, Paraben Free, Fragrance-Free, Sustainable, Clean Burning",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:05.096Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
